<template>
  <div v-if="free == 1" class="alert-free-account">
    <div class="alert-container">
      <div class="alert-content">
        <!-- Ícone simples -->
        <div class="alert-icon">
          <i class="fas fa-info-circle"></i>
        </div>

        <!-- Conteúdo principal -->
        <div class="alert-main">
          <p class="alert-message">
            <strong>Conta gratuita ativa até {{ last_day_to_access }}</strong>
            <span class="alert-days">
              - {{ daysRemaining }} dias restantes</span
            >
          </p>
          <p class="alert-action-text">
            Entre em contato para continuar usando após o período gratuito.
          </p>
        </div>

        <!-- Ações -->
        <div class="alert-actions">
          <v-btn
            small
            class="btn-modern btn-modern-save"
            @click="handleContact"
          >
            <i class="fas fa-phone mr-1"></i>
            Contato
          </v-btn>
        </div>

        <!-- Botão de fechar -->
        <button
          class="btn-dismiss"
          @click="handleDismiss"
          title="Dispensar por hoje"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { userData } from "../../lib/functions";
import moment from "moment";

export default {
  name: "AlertFreeAccount",

  data() {
    return {
      free: 0,
      free_days: 0,
      last_day_to_access: moment().format("DD/MM/YYYY"),
      rest_home_created_at: null,
    };
  },

  computed: {
    daysRemaining() {
      if (!this.rest_home_created_at) return 0;

      const endDate = moment(this.rest_home_created_at).add(
        this.free_days,
        "days"
      );
      const today = moment();
      const remaining = endDate.diff(today, "days");

      return Math.max(0, remaining);
    },
  },

  created() {
    this.retrieve();
    this.checkDismissed();
  },

  methods: {
    moment,

    async retrieve() {
      let { user } = userData();

      let { free, free_days, rest_home_created_at } = user;

      this.free = free;
      this.free_days = free_days;
      this.rest_home_created_at = rest_home_created_at;

      let last_day_to_access = moment(rest_home_created_at)
        .add(free_days, "days")
        .format("DD/MM/YYYY");

      this.last_day_to_access = last_day_to_access;
    },

    handleContact() {
      window.open(
        "https://wa.me/5511960671262?text=Olá! Gostaria de assinar o SistemaClin.",
        "_blank"
      );
    },

    handleDismiss() {
      // Esconde o alerta por hoje
      const today = moment().format("YYYY-MM-DD");
      localStorage.setItem("alert_free_account_dismissed", today);
      this.free = 0; // Esconde o componente
    },

    checkDismissed() {
      const dismissedDate = localStorage.getItem(
        "alert_free_account_dismissed"
      );
      const today = moment().format("YYYY-MM-DD");

      if (dismissedDate == today) {
        this.free = 0; // Esconde se já foi dispensado hoje
      }
    },
  },
};
</script>

<style scoped>
.alert-free-account {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-left: 4px solid #0f65b0;
  margin-bottom: 24px;
  border-radius: 0 8px 8px 0;
}

.alert-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.alert-content {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 0;
  position: relative;
}

/* Ícone simples */
.alert-icon {
  width: 40px;
  height: 40px;
  background: #0f65b0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
  flex-shrink: 0;
}

/* Conteúdo principal */
.alert-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.alert-message {
  color: #1e293b;
  font-size: 14px;
  margin: 0;
  font-weight: 500;
}

.alert-days {
  color: #64748b;
  font-weight: 400;
}

.alert-action-text {
  color: #64748b;
  font-size: 13px;
  margin: 0;
}

/* Ações */
.alert-actions {
  display: flex;
  gap: 12px;
  flex-shrink: 0;
}

.btn-contact {
  padding: 8px 16px;
  background: #0f65b0;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
}

.btn-contact:hover {
  background: #1e40af;
  transform: translateY(-1px);
}

/* Botão de fechar */
.btn-dismiss {
  background: transparent;
  color: #94a3b8;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.btn-dismiss:hover {
  background: #f1f5f9;
  color: #64748b;
}

/* Responsive Design */
@media (max-width: 768px) {
  .alert-container {
    padding: 0 16px;
  }

  .alert-content {
    gap: 12px;
    padding: 12px 0;
  }

  .alert-icon {
    width: 36px;
    height: 36px;
    font-size: 14px;
  }

  .alert-message {
    font-size: 13px;
  }

  .alert-action-text {
    font-size: 12px;
  }

  .btn-contact {
    padding: 6px 12px;
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .alert-content {
    flex-wrap: wrap;
  }

  .alert-main {
    flex: 1;
    min-width: 0;
  }

  .alert-actions {
    order: 3;
    width: 100%;
    justify-content: center;
    margin-top: 8px;
  }

  .btn-dismiss {
    order: 2;
    position: absolute;
    top: 8px;
    right: 8px;
  }
}

/* Utility classes */
.mr-1 {
  margin-right: 4px;
}
</style>